if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
 
        this.main_product_form = this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') || document.querySelector('.product__page form[action*="/cart/add"]') || document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add.js"]') || document.querySelector('form[action*="/cart/add"]');
        this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
        this.sectionId = this.dataset.sectionId;
 
        this.sellingPlanFormInput;
        if (!this.main_product_form.querySelector('input[name="selling_plan"]')) {
          this.sellingPlanFormInput = document.createElement('input');
          this.sellingPlanFormInput.setAttribute('type', 'hidden');
          this.sellingPlanFormInput.setAttribute('name', 'selling_plan');
          this.main_product_form.appendChild(this.sellingPlanFormInput);
        } else {
          this.sellingPlanFormInput = this.main_product_form.querySelector('input[name="selling_plan"]');
        }
        this.sellingPlanFormInput.setAttribute('value', '');
 
        // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
        if (this.main_product_form.querySelector('input[name="id"]') !== null) {
          this.main_product_form.querySelector('input[name="id"]').addEventListener('change', (event) => {
            this.handleVariantChange(event.target.value);
          });
        } else {
          if (typeof subscribe === 'function') {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.handleVariantChange(event.data.variant.id);
            });
          } else {
            document.addEventListener('variant:change', (event) => {
              this.handleVariantChange(event.detail.variant.id);
            });
          }
        }
      }
 
      connectedCallback() {
        // update when purchase type changes
        this.querySelectorAll('input[name="purchase_type"]').forEach((input) => {
          input.addEventListener('change', this.handleSellingPlanInput.bind(this));
        });
 
        // update when selling plan changes
        if (this.querySelector('.deployer-select')) {
          this.querySelector('.deployer-select').addEventListener('change', this.handleSellingPlanInputChange.bind(this));
        }

        // update when quantity changes
        document.addEventListener('form:quantity-update', this.handleQuantityUpdate.bind(this));
        document.addEventListener('quantity-breaks:quantity-selected', this.handleQuantityBreaksChange.bind(this));
      }
 
      handleVariantChange(variant_id) {
        this.toggleLoadingMode();
        this.renderSubscriptionWidget(variant_id);
      }

      get currentQuantity() {
        let quantityValue = document.querySelector('.js-qty-hidden')?.value || document.querySelector('quantity-breaks .selected-quantity-break')?.getAttribute('data-quantity');
        return parseInt(quantityValue);
      }
 
      async renderSubscriptionWidget(variant_id) {
        const productUrl = this.dataset.url;
        const requestedVariantId = variant_id;
        const sectionId = this.dataset.sectionId;
        fetch(`${productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHtml = new DOMParser().parseFromString(responseText, 'text/html');
            const source = responseHtml.getElementById(`subscription-widget__${this.dataset.sectionId}`);
            const destination = this;
            if (source && destination) destination.innerHTML = source.innerHTML;
            destination.connectedCallback();
            this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
            this.toggleLoadingMode();
          })
          .catch((error) => {
            console.error("Erreur en tentant de rafraichir le widget d'abonnement:", error);
            this.toggleLoadingMode();
          });
      }
 
      handleSellingPlanInputChange(e) {
        const quantity_breaks = document.querySelector('quantity-breaks');

        this.updateWidgetPrices(e.target, this.currentQuantity);
        if (quantity_breaks) quantity_breaks.handleQuantityUpdate(this.currentQuantity);
        this.handleSellingPlanInput(e);
      }

      updateWidgetPrices(select, quantity=1, quantity_break) {
        const oneTimeOriginalPriceContainer = this.querySelector('.subscription-widget__option--one-time .subscription-widget__option-price s');
        const oneTimeDiscountedPriceContainer = this.querySelector('.subscription-widget__option--one-time .subscription-widget__option-price span');
        const subscriptionOriginalPriceContainer = this.querySelector('.subscription-widget__option--subscription .subscription-widget__option-price s');
        const subscriptionDiscountedPriceContainer = this.querySelector('.subscription-widget__option--subscription .subscription-widget__option-price span');

        const quantityBreakOriginalPriceContainer = quantity_break?.querySelector('.quantity-break_price-container_compare-at-price');
        const quantityBreakDiscountedPriceContainer = quantity_break?.querySelector('.quantity-break_price-container_price');

        const selectedOption = select.options[select.selectedIndex];
        const adjustementType = selectedOption.dataset.ajustmentType;
        const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);
        
        let adjustedDiscountedPrice;
        let variantPrice = this.currentVariant.price;
        let adjustedVariantPrice = variantPrice;

        // Prix barré = prix de l'achat unique
        // Si un compare_at_price existe, on l'utilise.
        // Sinon on prend le prix de vente.
        let adjustedOriginalPrice = this.currentVariant.compare_at_price || variantPrice;   

        let selectedQuantityBreak = document.querySelector('.selected-quantity-break');

        if (selectedQuantityBreak) {
          let selectedQuantityBreakQuantity = parseInt(selectedQuantityBreak.getAttribute('data-quantity'));

          if (quantity < selectedQuantityBreakQuantity) {
              selectedQuantityBreak = selectedQuantityBreak.previousElementSibling;
          }
        }

        if (selectedQuantityBreak) {
          let selectedQuantityBreakDiscountValue = parseInt(selectedQuantityBreak.dataset.discountValue);
          let selectedQuantityBreakDiscountPercentage = parseInt(selectedQuantityBreak.dataset.discountPercentage);
          let discountValue = 0;

          if (selectedQuantityBreakDiscountValue > 0) {
            discountValue = selectedQuantityBreakDiscountValue;
          } else if (selectedQuantityBreakDiscountPercentage > 0) {
            discountValue = variantPrice * selectedQuantityBreakDiscountPercentage / 100;
          }

          variantPrice = variantPrice - discountValue;
        }

        if (quantity_break) variantPrice = quantityBreakDiscountedPriceContainer?.dataset.price || this.currentVariant.price;

        switch (adjustementType) {
          case 'fixed_amount':
            adjustedDiscountedPrice = variantPrice - adjustementValue;
            break;
          case 'percentage':
            adjustedDiscountedPrice = variantPrice * (1 - adjustementValue / 100);
            break;
          case 'price':
            adjustedDiscountedPrice = adjustementValue;
            break;
          default:
            adjustedDiscountedPrice = variantPrice;
            break;
        }

        adjustedOriginalPrice = adjustedOriginalPrice * quantity;
        if (quantity_break) quantity = 1;
        adjustedDiscountedPrice = adjustedDiscountedPrice * quantity;
        adjustedVariantPrice = variantPrice * quantity;

        if (oneTimeOriginalPriceContainer) {
          if (quantityBreakOriginalPriceContainer) {
            oneTimeOriginalPriceContainer.innerText = quantityBreakOriginalPriceContainer.innerText;
          } else {
            subscriptionOriginalPriceContainer.innerText = oneTimeDiscountedPriceContainer.innerText;
          }          
        }

        if (oneTimeDiscountedPriceContainer) {
          if (quantityBreakDiscountedPriceContainer) {
            oneTimeDiscountedPriceContainer.innerText = quantityBreakDiscountedPriceContainer.innerText;
          } else {
            oneTimeDiscountedPriceContainer.innerText = formatPrice(adjustedVariantPrice);
          }
        }

        if (subscriptionOriginalPriceContainer) subscriptionOriginalPriceContainer.innerText = formatPrice(adjustedVariantPrice);
        if (subscriptionDiscountedPriceContainer) subscriptionDiscountedPriceContainer.innerText = formatPrice(adjustedDiscountedPrice);

        this.updateSubscribeSavingPercentage(adjustedVariantPrice, adjustedDiscountedPrice);
      }
 
      updateSubscribeSavingPercentage(variantPrice, finalPrice) {
        const savingPercentageContainers = this.querySelectorAll('.subscription-widget__dynamic-discount');
        const variantPriceModified = variantPrice / 100;
        const finalPriceModified = finalPrice / 100;

        if (!savingPercentageContainers || variantPriceModified === finalPriceModified) return;
        savingPercentageContainers.forEach((container) => {
          const saving = ((variantPriceModified - finalPriceModified) / variantPriceModified) * 100;
          container.innerText = Math.round(saving) + '%';
        });
      }
 
      handleSellingPlanInput(e) {
        const selectedOption = e.target.closest('.subscription-widget__option');
        if (selectedOption) {
          selectedOption.querySelector('input[name="purchase_type"]').checked = true;
          this.querySelectorAll('.subscription-widget__option').forEach((option) => option.classList.remove('subscription-widget__option--selected'));
          selectedOption.classList.add('subscription-widget__option--selected');
        }
 
        if (selectedOption.classList.contains('subscription-widget__option--subscription')) {
          this.sellingPlanFormInput.value = selectedOption.querySelector('.deployer-select').options[selectedOption.querySelector('.deployer-select').selectedIndex].dataset.value;
        } else {
          this.sellingPlanFormInput.removeAttribute('value');
        }
      }

      handleQuantityUpdate(e) {
        const quantity_breaks = document.querySelector('quantity-breaks');
        const quantity = parseInt(e.detail.quantity);
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');

        this.updateWidgetPrices(select, quantity);
        if (quantity_breaks) quantity_breaks.handleQuantityUpdate(quantity);
      }

      handleQuantityBreaksChange(e) {
        const quantity_break = e.detail.quantity_break;
        const quantity = parseInt(e.detail.quantity);
        const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');

        this.updateWidgetPrices(select, quantity, quantity_break);
      }
 
      toggleLoadingMode() {
        this.classList.toggle('subscription-widget--loading');
      }
    }
  );
}